"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPCPositionTypesUK = exports.PPCPositionTypes = void 0;
var PPCPositionTypes;
(function (PPCPositionTypes) {
    PPCPositionTypes[PPCPositionTypes["ABOVE_DESCRIPTION"] = 1] = "ABOVE_DESCRIPTION";
    PPCPositionTypes[PPCPositionTypes["BELOW_DESCRIPTION"] = 2] = "BELOW_DESCRIPTION";
    PPCPositionTypes[PPCPositionTypes["BELOW_TECHNICAL_DETAILS"] = 3] = "BELOW_TECHNICAL_DETAILS";
    PPCPositionTypes[PPCPositionTypes["BELOW_BUY_BUTTON"] = 4] = "BELOW_BUY_BUTTON";
    PPCPositionTypes[PPCPositionTypes["ABOVE_BUY_BUTTON"] = 5] = "ABOVE_BUY_BUTTON";
})(PPCPositionTypes || (exports.PPCPositionTypes = PPCPositionTypes = {}));
var PPCPositionTypesUK;
(function (PPCPositionTypesUK) {
    PPCPositionTypesUK[PPCPositionTypesUK["ABOVE_DESCRIPTION"] = 1] = "ABOVE_DESCRIPTION";
    PPCPositionTypesUK[PPCPositionTypesUK["BELOW_DESCRIPTION"] = 2] = "BELOW_DESCRIPTION";
    PPCPositionTypesUK[PPCPositionTypesUK["BELOW_TECHNICAL_DETAILS"] = 3] = "BELOW_TECHNICAL_DETAILS";
    PPCPositionTypesUK[PPCPositionTypesUK["DIGITAL_PARTNER_MESSAGING"] = 5] = "DIGITAL_PARTNER_MESSAGING";
    PPCPositionTypesUK[PPCPositionTypesUK["BELOW_BUY_BUTTON"] = 6] = "BELOW_BUY_BUTTON";
    PPCPositionTypesUK[PPCPositionTypesUK["ABOVE_BUY_BUTTON"] = 7] = "ABOVE_BUY_BUTTON";
})(PPCPositionTypesUK || (exports.PPCPositionTypesUK = PPCPositionTypesUK = {}));
//# sourceMappingURL=PPCEnums.js.map